module.exports = __webpack_public_path__ + "img/user-centric.d51d635d.png";